import { Component, EventEmitter, HostListener, Input, Output } from "@angular/core";
import { InspectionReportListItem } from "../../../_objects/inspection-report";
import { TenantUser, TenantUserList } from "../../../_objects/user";
import { SharedLockService } from "../../../_services/shared-lock/shared-lock.service";
import { PERMISSION_CODE, PLATFORM } from "../../../app.constants";
import { NavigationExtras, Router } from "@angular/router";
import { NetworkStatusService } from "../../../_services/network-status.service";
import { TranslateService } from "@ngx-translate/core";
import { RoutePage } from "../../../app-routes.enum";

@Component({
  selector: "app-inspection-report-list-item",
  templateUrl: "./inspection-report-list-item.component.html",
  styleUrl: "./inspection-report-list-item.component.scss",
  standalone: false
})
export class InspectionReportListItemComponent {
  @Input() public report: InspectionReportListItem;
  @Input() public tenantUsers: TenantUserList[] = [];
  @Output() deleteReport = new EventEmitter<string>();
  public screenWidth: number;

  constructor(
    private networkStatusService: NetworkStatusService,
    private sharedLockService: SharedLockService,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.screenWidth = window.innerWidth;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    this.screenWidth = window.innerWidth;
  }

  editDelete() {
    this.deleteReport.emit(this.report.reportId);
  }

  isReadOnly() {
    return !this.report.permission || (this.report.permission & PERMISSION_CODE.WRITE) === 0;
  }

  menuEnabled() {
    return !this.sharedLockService.isReportLocked(this.report.inspection);
  }

  gotoInspectionReport(): void {
    if (this.sharedLockService.isReportLocked(this.report.inspection) && !this.sharedLockService.isLockedByCurrentUser(this.report.inspection)) {
      return;
    }

    let param: NavigationExtras;
    if (this.isDesktop && this.networkStatusService.isOnline && this.sharedLockService.isLockedByCurrentUser(this.report.inspection)) {
      param = { queryParams: { offlineDataUpdate: true } };
    }

    this.router.navigate([RoutePage.InspectionReport, this.report.inspection.id, this.report.reportId], param);
  }

  getUserName() {
    const user = this.tenantUsers.find((user) => user.id?.toLowerCase() === this.report.inspection.sharedLockBy?.toLowerCase());

    return user
      ? this.translateService.instant("inspectionreportlist.checkedOutBy") + user.givenName + " " + user.surname
      : this.translateService.instant("inspectionreportlist.checkedOut");
  }

  get isDesktop() {
    return this.networkStatusService.isDesktop();
  }

  get isOffline() {
    return this.networkStatusService.isOffline;
  }

  get isLocked() {
    return this.sharedLockService.isReportLocked(this.report.inspection);
  }

  get isSharedLockByCurrentUser() {
    return this.sharedLockService.isLockedByCurrentUser(this.report.inspection);
  }
}
